module.exports = __webpack_public_path__ + "static/img/version1.41196b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/version1.png
// module id = iqfx
// module chunks = 1